import { create } from "@/api/launcherApp/signup"
import type { TApiSignupCreateParams, TApiSignupCreateResponse } from "@/api/launcherApp/signup/schema"
import { createScopedLogger } from "@/lib/observability"
import { publishSlackNotification } from "@/lib/slackNotifications"
import { buildSignupSlackPayload, SignupSlackNotificationInputSchema, type SignupSlackNotificationInput } from "./slackPayload"

const logger = createScopedLogger("signup", {
  action: "create",
})

async function publishSignupCreatedSlackNotification(signupInfo: SignupSlackNotificationInput | undefined) {
  if (!signupInfo) {
    return
  }

  const parsedSignupInfo = SignupSlackNotificationInputSchema.safeParse(signupInfo)

  if (!parsedSignupInfo.success) {
    logger.warn("signup.slack_notification.invalid_input", {
      issueCount: parsedSignupInfo.error.issues.length,
    })
    return
  }

  try {
    const result = await publishSlackNotification(buildSignupSlackPayload(parsedSignupInfo.data))

    if (!result.ok) {
      logger.warn("signup.slack_notification.skipped", {
        reason: result.error,
      })
    }
  } catch (error) {
    await logger.error("signup.slack_notification.failed", error)
  }
}

export async function actionCreateSignup(params: TApiSignupCreateParams, signupInfo?: SignupSlackNotificationInput): Promise<{ success: boolean; data?: TApiSignupCreateResponse }> {
  try {
    const result = await create(params)

    if (result.success) {
      await publishSignupCreatedSlackNotification(signupInfo)
    }

    return { success: true, data: result }
  } catch (error) {
    await logger.error("signup.create.action_failed", error)
    return { success: false }
  }
}
